import { useEffect } from "react";
import { useDisconnect } from "wagmi";
import TokenService, { ONE_HOUR } from "../../services/token.service";

function useTokenChecker() {
  const { disconnect } = useDisconnect();

  useEffect(() => {
    TokenService.registerDisconnectFn(disconnect);

    const intervalId = setInterval(() => {
      const token = TokenService.tokens;
    }, ONE_HOUR);

    return () => clearInterval(intervalId);
  }, [disconnect]);
}

export default useTokenChecker;
